<template>
    <div class="navbar">
        <a class="warning-button-outlined" :href="href" id="return_button" @mouseover="showBack = true" @mouseleave="showBack = false" >
            <i class="material-icons">undo</i>&nbsp;
            Retour&nbsp;
            <Transition  name="expand-width">
                <div  id="back_to" v-if="showBack" class="expandBox">
                    <slot name="back"></slot>
                </div>
            </Transition>
        </a>
        <h1><span class="navbar-title"><slot name="title"></slot></span></h1>
        <template class="bonus">
          <slot name="action_bonus"></slot>
        </template>
    </div>
</template>

<script setup>

import {ref} from 'vue'

const showBack = ref(false)

defineProps({
  href:String
})

</script>

<style scoped lang="scss">

.navbar{
    display: grid;
    grid-template-columns: repeat(3,1fr);
    justify-items: center;
    align-items: center;
}

.bonus{
  justify-content: end;
  width: 100%;
  display: flex;
}

#return_button {
  display: inline-flex;      /* or inline-block/flex */
  align-items: center;       /* vertically center content */
  height: 25px;              /* fix the total height */
  line-height: 25px;         /* so text is centered if you prefer text-based centering */
  overflow: hidden;          /* hide anything that overflows vertically */
  justify-self: self-start;
}

.expand-box {
  /* put it inline-block so it can grow horizontally */
  display: inline-block;
  overflow: hidden;
  white-space: nowrap; /* prevent multi-line wrap, if you want a single line */
}

/* The "expand-width" transition classes: */
.expand-width-enter-from,
.expand-width-leave-to {
  max-width: 0;
  opacity: 0;
}

.expand-width-enter-to,
.expand-width-leave-from {
  /* "200px" is a guess at the maximum width your text might need. 
     Use a suitably large number for your slot. */
  max-width: 200px;
  opacity: 1;
}

.expand-width-enter-active{
  transition: max-width 0.5s ease, opacity 0.6s ease;
}

.expand-width-leave-active {
  transition: max-width 0.7s ease, opacity 0.3s ease;
}

h1{
  text-align: center;
}

.navbar-title {
  white-space: nowrap;        
  overflow: hidden;            
  text-overflow: ellipsis;     
  max-width: 100%;             
  display: inline-block;
}
</style>